"use strict";

import "angular";
import "google";

import GeoTree from "utils/geo-tree/geo-tree";

function serialize(obj) {
  let str =
    "?" +
    Object.keys(obj)
      .reduce(function (a, k) {
        a.push(k + "=" + encodeURIComponent(obj[k]));
        return a;
      }, [])
      .join("&");
  return str;
}

function processFilter(f) {
  let nF = angular.copy(f);
  if (nF.after) nF.after = nF.after.toISOString();
  if (nF.before) nF.before = nF.before.toISOString();
  return serialize(nF);
}

function _iconForLabels(labels) {
  function _icon(color, size, opacity) {
    return {
      url: "/static/daupler/img/icons/marker-" + color + ".svg",
      scaledSize: new google.maps.Size(size, size),
      opacity: opacity || 1,
    };
  }
  if (labels.indexOf("Sewer Backup") >= 0) return _icon("brown", 72);
  if (labels.indexOf("Odor Complaint") >= 0) return _icon("lightGreen", 54);
  if (labels.indexOf("Manhole Issue") >= 0) return _icon("grey", 54);
  if (labels.indexOf("Sewer") >= 0) return _icon("lightBrown", 48);
  if (labels.indexOf("Water Leaking") >= 0) return _icon("blue", 72);
  if (labels.indexOf("Water Quality") >= 0) return _icon("purple", 54);
  if (labels.indexOf("Water") >= 0) return _icon("lightBlue", 54);
  return _icon("black", 48);
}

export default function ($window, $interpolate, $http, $q, $timeout, toastr) {
  "ngInject";

  var vm = this;

  vm.views = {
    HEATMAP: 0,
    RESPONSIVENESS: 1,
    PERFORMANCE: 2,
    CALLS: 3,
  };

  vm.showHeatmap = false;
  vm.heatmapFilter = {};
  vm.heatmapLabels = {};
  vm.loadedHeatmapFilter = {};
  vm.showHeatmapDetail = false;

  vm.deleteHeatmapFilterField = function (field) {
    delete vm.heatmapFilter[field];
    if (field === "labels") {
      for (const label in vm.heatmapLabels) {
        vm.heatmapLabels[label] = false;
      }
    }
    vm.heatmapFilterUpdated = true;
  };

  vm.toggleHeatmapLabel = function (label) {
    let filterCopy = !angular.copy(vm.heatmapFilter);
    let existingLabels;
    if (vm.heatmapFilter.labels) {
      existingLabels = vm.heatmapFilter.labels.split(",");
    } else {
      existingLabels = [];
    }
    let idx = existingLabels.indexOf(label);
    if (idx >= 0) {
      existingLabels.splice(idx, 1);
    } else {
      existingLabels.push(label);
    }
    if (existingLabels.length > 0) {
      vm.heatmapFilter.labels = existingLabels.join(",");
    } else {
      delete vm.heatmapFilter.labels;
    }
    vm.heatmapFilterUpdated = true;
  };

  function _shouldShowHeatmapDetails() {
    const zoom = vm.map.getZoom();
    const sufficientlyZoomed = zoom >= 16;
    const kindOfZoomed = 13 <= zoom && zoom <= 15;
    let sufficientlyFewMarkers = null;
    if (kindOfZoomed && vm.geoTree) {
      const bounds = vm.map.getBounds();
      const ne = bounds.getNorthEast();
      const sw = bounds.getSouthWest();
      const neCoords = { lat: ne.lat(), lng: ne.lng() };
      const swCoords = { lat: sw.lat(), lng: sw.lng() };
      const pointsInMap = vm.geoTree.find(neCoords, swCoords, 31);
      sufficientlyFewMarkers = pointsInMap.length <= 30;
    }
    return sufficientlyZoomed || sufficientlyFewMarkers;
  }

  vm.buildHeatmap = function (zoom, lat, lng, displayMap) {
    if (!vm.map) {
      vm.map = new google.maps.Map(
        document.getElementById("analytics-heatmap"),
        {
          zoom: zoom,
          center: {
            lat: lat,
            lng: lng,
          },
          mapTypeId: "satellite",
          mapTypeControl: false,
          // mapTypeControl: true,
          // mapTypeControlOptions: {
          // 	style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
          // 	position: google.maps.ControlPosition.TOP_RIGHT,
          // },
          scaleControl: false,
          streetViewControl: false,
          rotateControl: false,
          fullscreenControl: false,
        },
      );

      function _handleBoundsUpdate() {
        if (_shouldShowHeatmapDetails()) {
          buildHeatmapDetail();
        } else {
          vm.hideDetails();
        }
      }

      vm.map.addListener("bounds_changed", function (event) {
        if (vm.mapBoundsChangedTimeout)
          $timeout.cancel(vm.mapBoundsChangedTimeout);
        vm.mapBoundsChangedTimeout = $timeout(() => {
          _handleBoundsUpdate();
        }, 200);
      });
    }

    vm.heatmapLoading = true;
    $http({
      method: "GET",
      url: "/analytics/beta/v2/heatmap" + processFilter(vm.heatmapFilter),
    })
      .then((response) => {
        if (vm.heatmap) {
          vm.heatmap.setMap(null);
          delete vm.heatmap;
        }
        vm.loadedHeatmapFilter = angular.copy(vm.heatmapFilter);
        vm.loadedHeatmapFilter.labels = vm.heatmapFilter.labels
          ? vm.heatmapFilter.labels.split(",")
          : null;
        vm.heatmapLabelCounts = response.data.labels;
        vm.geoTree = new GeoTree();
        response.data.points.forEach(function (p) {
          vm.geoTree.insert(p[0], p[1], new google.maps.LatLng(p[0], p[1]));
        });
        vm.heatmapNoPoints = response.data.points.length === 0;
        vm.heatmap = new google.maps.visualization.HeatmapLayer({
          data: vm.geoTree.find(),
          map: vm.map,
          radius: 20,
          maxIntensity: 3,
        });
        if (_shouldShowHeatmapDetails()) {
          buildHeatmapDetail();
        } else {
          vm.hideDetails();
        }
      })
      .finally(() => {
        vm.heatmapFilterUpdated = false;
        vm.heatmapLoading = false;
      });

    if (displayMap) {
      vm.showHeatmap = true;
      vm.selectedView = vm.views.HEATMAP;
    }
  };

  vm.updateHeatmapTimesFromIncident = function (field, incident) {
    switch (field) {
      case "after":
        vm.heatmapFilter[field] = new Date(
          new Date(incident.time).getTime() - 1000 * 60 * 60,
        );
        break;
      case "before":
        vm.heatmapFilter[field] = new Date(
          new Date(incident.time).getTime() + 1000 * 60 * 60,
        );
        break;
      case "around":
        vm.heatmapFilter.after = new Date(
          new Date(incident.time).getTime() - 1000 * 60 * 60 * 24 * 3,
        );
        vm.heatmapFilter.before = new Date(
          new Date(incident.time).getTime() + 1000 * 60 * 60 * 24 * 3,
        );
        break;
    }
    vm.buildHeatmap();
  };

  vm.setHeatmapLabels = function (labels) {
    for (const label in vm.heatmapLabels) {
      vm.heatmapLabels[label] = false;
    }
    for (const label of labels) {
      vm.heatmapLabels[label] = true;
    }
    vm.heatmapFilter.labels = labels.join(",");
    vm.buildHeatmap();
  };

  let heatmapDetailMarkers = [];
  let loadingHeatmapDetails = false;

  function buildHeatmapDetail() {
    if (vm.heatmapDetailCanceler) {
      vm.heatmapDetailCanceler.resolve();
    }

    // If only the bounds have been updated, then we pass true to the
    // hideDetailMarkers function, so that it does not remove/add the same
    // markers again.  However, if the filter has also been updated, then we do
    // a full refresh.
    const oldBounds = vm.oldBounds;
    const oldFilter = vm.oldFilter;
    vm.oldBounds = vm.map.getBounds();
    vm.oldFilter = Object.assign({}, vm.heatmapFilter);
    const filterUpdated = !angular.equals(vm.oldFilter, oldFilter);
    loadingHeatmapDetails = true;
    vm.showHeatmapDetail = true;
    const bounds = vm.map.getBounds();
    const ne = bounds.getNorthEast();
    const sw = bounds.getSouthWest();
    const f = Object.assign({}, vm.heatmapFilter);
    f.bounds = `${ne.lat()},${ne.lng()},${sw.lat()},${sw.lng()}`;

    vm.heatmapDetailCanceler = $q.defer();
    $http({
      method: "GET",
      url: "/analytics/beta/v2/heatmap/detail" + processFilter(f),
      timeout: vm.heatmapDetailCanceler,
    })
      .then((response) => {
        vm.heatmapDetails = response.data;
        vm.hideDetailMarkers(filterUpdated);
        vm.heatmapDetails.forEach((incident) => {
          incident.latlng.forEach((point) => {
            const position = new google.maps.LatLng(point[0], point[1]);
            if (!filterUpdated && oldBounds && oldBounds.contains(position))
              return;
            const marker = new google.maps.Marker({
              map: vm.map,
              position: position,
              icon: _iconForLabels(incident.labels),
              animation: 4,
            });
            const contentHtml = `
					<div>
						<b>{{ incident.labels.join('/') }}</b>
						&middot;
						{{ incident.time | date:"M/d/yy '&middot;' h:mm a" }}
						&middot;
						<a href="/incident/${incident.uuid}/" target="_blank">
							View details
							<i style="font-size: 12px;" class="material-icons">open_in_new</i>
						</a>
						<br>
						{{ incident.description }}
					</div>
					`;
            const infoWindow = new google.maps.InfoWindow({
              content: $interpolate(contentHtml)({ incident: incident }),
            });
            marker.addListener("click", function () {
              if (vm.openInfoWindow) {
                vm.openInfoWindow.close();
              }
              if (vm.openInfoWindow === infoWindow) {
                delete vm.openInfoWindow;
                return;
              }
              vm.openInfoWindow = infoWindow;
              infoWindow.open(vm.map, marker);
            });
            heatmapDetailMarkers.push({
              incident: incident,
              marker: marker,
            });
          });
        });
      })
      .finally(() => {
        delete vm.heatmapDetailCanceler;
        loadingHeatmapDetails = false;
      });
  }

  vm.animateIncidentMarkers = function (incident) {
    const bounds = vm.map.getBounds();
    heatmapDetailMarkers.forEach((data) => {
      if (incident && data.incident.uuid == incident.uuid) {
        data.marker.setAnimation(google.maps.Animation.BOUNCE);
      } else {
        data.marker.setAnimation(null);
      }
    });
  };

  vm.hideDetailMarkers = function (force) {
    const goodMarkers = [];
    heatmapDetailMarkers.forEach((data) => {
      if (
        !force &&
        vm.showHeatmapDetail &&
        vm.map.getBounds().contains(data.marker.getPosition())
      ) {
        goodMarkers.push(data);
      } else {
        data.marker.setMap(null);
      }
    });
    heatmapDetailMarkers = goodMarkers;
  };

  vm.hideDetails = function () {
    vm.oldBounds = null;
    vm.oldFilter = null;
    vm.heatmapDetails = null;
    vm.showHeatmapDetail = false;
    vm.hideDetailMarkers(true);
  };

  vm.rsvpFilter = {};
  vm.rsvpUserOverallOptions = {
    legend: {
      display: true,
    },
  };

  vm.deleteRsvpFilterField = function (field) {
    delete vm.rsvpFilter[field];
    vm.rsvpFilterUpdated = true;
  };

  vm.rsvpLoad = function () {
    if (!vm.rsvpData) {
      vm.rsvpDataLoading = true;
      const selectedUser = vm.rsvpUser;
      $http({
        method: "GET",
        url: "/analytics/beta/v2/responsiveness" + processFilter(vm.rsvpFilter),
      })
        .then((response) => {
          if (!response.data) {
            toastr.warning("No calls occurred in the selected time range");
            return;
          }
          vm.rsvpLoadedFilter = Object.assign({}, vm.rsvpFilter);
          vm.rsvpGlobalData = response.data;
          if (selectedUser) {
            vm.rsvpLoadDetail(selectedUser, true);
          }
        })
        .finally(() => {
          vm.rsvpFilterUpdated = false;
          vm.rsvpDataLoading = false;
        });
    }
    vm.selectedView = vm.views.RESPONSIVENESS;
  };

  vm.rsvpLoadDetail = function (user, force) {
    if (!force && vm.rsvpUser === user) return;
    vm.rsvpDetailLoading = true;
    vm.rsvpLoadingUser = user;
    const f = Object.assign({}, vm.rsvpFilter);
    f.user_uuid = user.uuid;
    $http({
      method: "GET",
      url: "/analytics/beta/v2/responsiveness/detail" + processFilter(f),
    })
      .then((response) => {
        vm.rsvpUser = user;
        vm.rsvpDetailData = response.data;
      })
      .finally(() => {
        vm.rsvpDetailLoading = false;
        vm.rsvpLoadingUser = null;
      });
  };

  vm.rsvpHideDetail = function () {
    vm.rsvpUser = null;
  };

  vm.performanceFilter = {};

  vm.deleteperformanceFilterField = function (field) {
    delete vm.performanceFilter[field];
    vm.performanceFilterUpdated = true;
  };

  vm.performanceLoad = function () {
    if (!vm.performanceDataLoading) {
      vm.performanceDataLoading = true;
      const selectedUser = vm.performanceUser;
      $http({
        method: "GET",
        url:
          "/analytics/beta/v2/performance" +
          processFilter(vm.performanceFilter),
      })
        .then((response) => {
          if (!response.data) {
            return;
          }
          vm.performanceLoadedFilter = Object.assign({}, vm.performanceFilter);
          vm.performanceGlobalData = response.data;
          if (selectedUser) {
            vm.performanceLoadDetail(selectedUser, true);
          }
        })
        .finally(() => {
          vm.performanceFilterUpdated = false;
          vm.performanceDataLoading = false;
        });
    }
    vm.selectedView = vm.views.PERFORMANCE;
  };

  vm.performanceLoadDetail = function (user, force) {
    if (!force && vm.performanceUser === user) return;
    vm.performanceDetailLoading = true;
    vm.performanceLoadingUser = user;
    const f = Object.assign({}, vm.performanceFilter);
    f.leader_uuid = user.uuid;
    $http({
      method: "GET",
      url: "/analytics/beta/v2/performance/detail" + processFilter(f),
    })
      .then((response) => {
        vm.performanceUser = user;
        vm.performanceDetailData = [[], [], [], []];
        const r = 5;
        response.data.forEach((x) => {
          for (var i = 0; i < 4; i++) {
            if (x[1][i]) {
              vm.performanceDetailData[i].push({
                x: x[0],
                y: x[1][i] / 60,
                r: r,
              });
            }
          }
        });
        vm.performanceDetailData;
      })
      .finally(() => {
        vm.performanceDetailLoading = false;
        vm.performanceLoadingUser = null;
      });
  };

  vm.performanceHideDetail = function () {
    vm.performanceUser = null;
  };

  vm.callsFilter = {};

  vm.deleteCallsFilterField = function (field) {
    delete vm.callsFilter[field];
    vm.callsFilterUpdated = true;
  };

  function getMsForDays(days) {
    return 1000 * 60 * 60 * 24 * days;
  }

  function isCallsFilterValid(maxAnalyticsDays = 9) {
    const maxRangeMs = getMsForDays(maxAnalyticsDays);
    var startMs = new Date(vm.callsFilter.before).getTime();
    var endMs = new Date(vm.callsFilter.after).getTime();
    var diffBetweenFilters = Math.abs(endMs - startMs);
    return diffBetweenFilters <= maxRangeMs;
  }

  vm.callsLoad = function (maxAnalyticsDays = 9) {
    if (!vm.callsFilter.before || !vm.callsFilter.after) {
      var lastMonday = new Date();
      lastMonday.setDate(
        lastMonday.getDate() - ((6 + lastMonday.getDay()) % 7),
      );
      vm.callsFilter.after = lastMonday;
      const nextSunday = new Date(lastMonday.getTime() + getMsForDays(6));
      vm.callsFilter.before = nextSunday;
    }
    if (!isCallsFilterValid(maxAnalyticsDays)) {
      toastr.warning(`Cannot query longer than ${maxAnalyticsDays} days`);
      return;
    }

    if (!vm.callsDataLoading) {
      vm.callsDataLoading = true;
      $http({
        method: "GET",
        url: "/analytics/beta/v2/calls" + processFilter(vm.callsFilter),
      })
        .then((response) => {
          if (!response.data) {
            return;
          }
          vm.callsLoadedFilter = Object.assign({}, vm.callsFilter);
          vm.callsData = response.data;
        })
        .finally(() => {
          vm.callsFilterUpdated = false;
          vm.callsDataLoading = false;
        });
    }
    vm.selectedView = vm.views.CALLS;
  };

  vm.callsExport = function (
    incidentCount,
    maxAnalyticsDays = 9,
    maxCallCount = 500,
  ) {
    if (!isCallsFilterValid(maxAnalyticsDays)) {
      toastr.warning(`Cannot export longer than ${maxAnalyticsDays} days`);
      return;
    }
    if (incidentCount > maxCallCount) {
      toastr.warning(`Cannot export more than ${maxCallCount} calls`);
      return;
    }
    var url = "/analytics/beta/v2/calls-csv" + processFilter(vm.callsFilter);
    $window.open(url, "_blank");
  };
}
